import { Component } from '@angular/core';

@Component({
    selector: 'r1-compass-app-ng-eighteen',
    imports: [],
    template: `
        <h1>Angular 18</h1>
        <section>
            <h2>New signal APIs</h2>
            <p>
                Signal based API:
                <code>input, output, model, viewChild, viewChildren, contentChild, contentChildren</code>
            </p>
            <p>
                <code>model</code> is new. The other ones "replace" {{ atSymbol }} based APIs (like <code>input</code>).
                The old {{ atSymbol }} ones are NOT deprecated. But these ones have better features that I will explain
                later. You have probably seen <code>input</code> a lot as it came out in Angular 17.1. It's great.
            </p>
            <h2>
                <code>output</code> replacing (not deprecating) <code>{{ atSymbol }}Output</code>
            </h2>
            <p>
                A maintainer of NGXS and content creator for Angular, Profanis goes over the new API for
                <code>output</code>. This new <code>output</code> does not deprecate <code>{{ atSymbol }}Output</code>,
                but it has better features.
            </p>
            <p>Note: NOT a signal. They are just staying consistent with not using {{ atSymbol }} anymore.</p>
            <p>Disclaimer from his comments, about the unneeded non null assertion <code>!</code>:</p>
            <blockquote>
                Some corrections: In the parent component, we use the viewchild to query the child component. The child
                component might be undefined and that's why we use a condition. Since we know that the child component
                will be rendered, we can skip the if condition by simply marking the viewchild as required. The code
                will become: childComponentRef = viewChild. required (ChildComponent);
            </blockquote>
            <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/_uAIJqf3ILc?si=FLpXNEg9J_AH-s2C"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen></iframe>
        </section>

        <section>
            <h2>Unified form events</h2>
            <a href="https://github.com/ngxtension/ngxtension-platform/issues/376" target="_blank"
                >Link to an ourstanding issue in the library we use for utils. I explain it in detail. This is a big
                deal and I intend to pull this stuff in manually soon if it is not included in the util library.</a
            >
            <br />
            <p>
                I gave Igor some feedback on the first draft of this video. He has the best presentation of new code
                concepts in Angular.
            </p>
            <br />
            <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/v7r-7PHaEtY?si=KZp3jfu1g_8koN3D"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen></iframe>

            <p>
                Example I made during a release candidate. Things have changed since then a bit. Just the name of the
                events (which with my utils you don't need to know), and now submitted and reset have events.
            </p>
            <iframe
                src="https://stackblitz.com/edit/v18-unified-control-state-change-ncedaj?embed=1&file=src%2Fmain.ts"
                width="1200"
                height="600"></iframe>
        </section>
        <section>
            <h2>New Material Customizations</h2>
            <a href="https://www.reddit.com/r/Angular2/comments/1cvp1rd/comment/l4qwob5/" target="_blank"
                >Example Stackblitz + video + explanation. Big deal IMO. We can use variables like these in ours to a
                limited extent, but I have to port us over to use M3 first.</a
            >
            <br />
            <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/DpCwKpZlcbg?si=7a-kWZ1dEjY4zaRZ"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen></iframe>
            <p>Example I made. We have used it in some (not yet as of 18 upgrade story) stories.</p>
            <iframe
                src="https://stackblitz.com/edit/9wccoq?embed=1&file=src%2Fexample%2Froot.ts"
                width="1200"
                height="600"></iframe>
        </section>
        <section>
            <h2>TS 5.3 & 5.4</h2>
            <a href="https://devblogs.microsoft.com/typescript/announcing-typescript-5-3/" target="_blank">5.3</a>
            <p>Type Narrowing in <code>switch(true)</code></p>
            <pre>
                <code>
                    {{ switchNarrowing }}
                </code>
            </pre>
            <br />
            <a href="https://devblogs.microsoft.com/typescript/announcing-typescript-5-4/" target="_blank">5.4</a>
            <p>Object (and also Map) <code>groupBy</code></p>
            <pre>
                <code>
                    {{objectGroupBy}}
                </code>
            </pre>
        </section>
    `,
    styles: ``,
})
export class NgEighteenComponent {
    atSymbol = '@' as const;

    switchNarrowing = `
    function f(x: unknown) {
        switch (true) {
            case typeof x === "string":
                // 'x' is a 'string' here
                console.log(x.toUpperCase());
                // falls through...

            case Array.isArray(x):
                // 'x' is a 'string | any[]' here.
                console.log(x.length);
                // falls through...

            default:
              // 'x' is 'unknown' here.
              // ...
        }
    }

    `;

    objectGroupBy = `
    const array = [0, 1, 2, 3, 4, 5];

    const myObj = Object.groupBy(array, (num, index) => {
        return num % 2 === 0 ? "even": "odd";
    });
    // equivalent to
    const myObj = {
        even: [0, 2, 4],
        odd: [1, 3, 5],
    };
    `;
}
